
<script setup>

  import { ref } from 'vue';

  import { ArrowLeftCircleIcon, ArrowRightCircleIcon } from '@heroicons/vue/24/outline';

  import SaveNotice from '../partials/save-notice.vue';

  import { photo3Questions } from '../stores/activity-1.js';

  import Numbers from '../components/numbers.vue';

  import TextArea from '../components/text-area.vue';

  const ready = ref( false );

  setTimeout( () => ready.value = true, 100 );

</script>

<template>

  <article>

    <div class="grid lg:grid-cols-2 min-h-view gap-12 p-6 md:p-12 lg:p-24">

      <div :class="[ 'self-center justify-self-center max-w-xl transition-[opacity,transform] duration-1000', { 'opacity-0 -translate-x-full': ! ready } ]">

        <div class="uppercase text-neutral-600 font-bold">Activity 1: Hearing All the Stories</div>

        <div class="flex items-center gap-2 mt-2">
          
          <span class="uppercase text-neutral-600 font-bold">Photo</span>

          <Numbers :current="3" :total="4" />

        </div>

        <h2 class="mt-6 pb-6 text-4xl md:text-5xl font-heading uppercase border-b-[3px] border-black">Desegregation in Action</h2>

        <p class="mt-8 leading-7 text-neutral-700">

          In 1954 the Supreme Court declared segregation

          unconstitutional and called for desegregation. In 1957 nine

          black students enrolled to attend Little Rock Central High

          School. The photo shows Elizabeth Eckford arriving for

          the first day of school on September 4.

        </p>

        <p class="mt-4 leading-7 text-neutral-700">

          Study the photo and react to the discussion prompts below.

        </p>

        <figure class="lg:hidden mt-12">

          <img class="w-full" src="../images/activity-1-photo-3.jpg"

            alt="Elizabeth Eckford arriving for the first day of school. A crowd of angry people are seen following behind her. One woman is screaming directly behind Ms. Eckford. The woman to Ms. Eckford's left is grimacing. The woman to Ms. Eckford's right is talking and not looking toward Elizabeth." />

          <figcaption class="inline-flex p-6 italic text-sm font-bold bg-amber-300 shadow-md -translate-x-4 -translate-y-4">
            
            Elizabeth Eckford arriving for the first day of school.
          
          </figcaption>

        </figure>

        <div v-for="( { id, question, answer }, index ) in photo3Questions" :key="id" class="max-w-xl mt-12">
          
          <label class="font-bold" :for="id">{{ index + 1 }}. {{ question }}</label>
        
          <TextArea :id="id" v-model="answer.value" v-slot="{ count, maxLength }">
            
            <div class="text-right mt-2 text-sm italic">{{ count }} of {{ maxLength }} characters used.</div>
          
          </TextArea>

        </div>

        <SaveNotice class="mt-12" />

        <div class="flex flex-wrap justify-between gap-6 max-w-xl mt-12">

          <RouterLink

            class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold text-white bg-neutral-600 transition-colors
                
              hover:bg-neutral-700 focus-visible:bg-neutral-700 hover:underline focus-visible:underline"
          
            to="/activity/1/photo/2">
            
            <ArrowLeftCircleIcon class="w-8" />

            <span>Back</span>
          
          </RouterLink>

          <RouterLink

            class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold text-white bg-green-700 transition-colors
            
              hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
          
            to="/activity/1/photo/4">
            
            <span>Next</span>

            <ArrowRightCircleIcon class="w-8" />
          
          </RouterLink>

        </div>

      </div>

      <div :class="[ 'hidden lg:block transition-[opacity,transform] duration-700', { 'opacity-0 translate-x-full': ! ready } ]">

        <figure class="sticky top-40">

          <img class="w-full" src="../images/activity-1-photo-3.jpg"
          
            alt="Elizabeth Eckford arriving for the first day of school. A crowd of angry people are seen following behind her. One woman is screaming directly behind Ms. Eckford. The woman to Ms. Eckford's left is grimacing. The woman to Ms. Eckford's right is talking and not looking toward Elizabeth." />

          <figcaption class="inline-flex p-6 italic text-sm font-bold bg-amber-300 shadow-md -translate-x-4 -translate-y-4">
            
            Elizabeth Eckford arriving for the first day of school.
          
          </figcaption>

        </figure>

      </div>

    </div>

  </article>

</template>
